module.exports = __webpack_public_path__ + "img/term_hint.ad3cc3cd.png";